// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4044":"e37e8c42","4063":"3242e2f7"}[chunkId] + ".chunk.css";
};